import * as types from '../const/action.types';

export function machine(state = {}, action) {
    switch (action.type) {
        case types.LOAD_MACHINE_SUCCESS:
            return action.data;
        default:
            return state;
    }
}

export function machines(state = [], action) {
    switch (action.type) {
        case types.MACHINES_SUCCESS:
            return action.data;
        case types.XEF_ADD_EVENTS:
            const arr = [].concat([...state]);
            action.events
                .filter((f) => f.evento && f.evento.startsWith('MAQ_'))
                .forEach((e) => {
                    const produccion = e.payload;
                    let found = false;
                    arr.forEach((i, index) => {
                        if (i.id === produccion.id) {
                            arr[index] = produccion;
                            found = true;
                        }
                    });
                    if (!found) {
                        arr.push(produccion);
                    }
                });
            return arr;
        default:
            return state;
    }
}

export function machinesHasErrored(state = { hasErrored: false, error: '' }, action) {
    switch (action.type) {
        case types.MACHINES_HAS_ERROR:
            return {
                hasErrored: action.hasErrored,
                error: action.error,
            };

        default:
            return state;
    }
}

export function machinesIsLoading(state = false, action) {
    switch (action.type) {
        case types.MACHINES_IS_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/machine.reducer.js